export enum InputWidth {
  tiny = 'tiny',
  small = 'small',
  medium = 'medium',
  large = 'large',
  default = 'default',
  full = 'full',
}
